import { memo } from 'react';
import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * "Not imported (N)": the columns of the file that are left out.
 *
 * @param {object} props
 * @param {string[]} props.columns
 */
function NotImportedList({ columns }) {
  const { t } = useTranslation('people-access');
  if (columns.length === 0) return null;

  return (
    <div data-testid="not-imported" className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-semibold text-content">
        {t('import.match.notImported', { count: columns.length })}
      </span>
      {columns.map((column) => (
        <Badge key={column} size="small" variant="neutral">
          {column}
        </Badge>
      ))}
    </div>
  );
}

export default memo(NotImportedList);
